const {BlockSubscription} = require("./BlockSubscription");
const {InMemoryBlockStorage} = require("./InMemoryBlockStorage");

module.exports = {BlockSubscription, InMemoryBlockStorage};
